/**
 * @generated SignedSource<<09928f3b01de4dd1cdcc47ea8b9568f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhoneEditConfirm$data = {
  readonly newPhone: string | null;
  readonly " $fragmentType": "PhoneEditConfirm";
};
export type PhoneEditConfirm$key = {
  readonly " $data"?: PhoneEditConfirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhoneEditConfirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhoneEditConfirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newPhone",
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "ef4bca3a2057949c2ca44872df80ca87";

export default node;
